module.exports = __webpack_public_path__ + "img/8_Train-01-center.9790caac.png";